import 'react-datepicker/dist/react-datepicker.css';

import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Spinner } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { STATE_STATUS, FORM_MODE } from '@awp/constants';
import ValidationModal from '@components/ManualValidation/validationModal';
import { useMultiStationContext } from '@components/Graphs/MultiStation/MultiStationContext';
import { overlayStyle, spinnerStyle } from '@components/Common/AwpStyles';

import {
  fetchData,
  selectWeatherStation,
  selectStartDate,
  selectEndDate,
  selectShowConfidenceLevel,
  selectShowInvalidData,
  selectShowValidData,
  getSelectedDatasetsByUserPreset,
  selectMultiStationData,
  fetchMultiStationData,
  derivedObservatioIds,
} from '@stores/dataVisualizationSlice';

import { selectSelectedDatasetOptions } from '@awp/stores/dataTablePageSlice';
import TableView from '@components/dataTables/TableView';
import { selectAllUserPresets } from '@stores/userPresetSlice';

const DataTableRenderer = () => {
  const { status, weatherStations, presetId, weatherStationId, dataRange, isSelectedDeferOnlyPreset } =
    useMultiStationContext();
  const loading = status.multiStationData === STATE_STATUS.LOADING;
  const dispatch = useDispatch();

  const weatherStation = useSelector(selectWeatherStation);
  const data = useSelector(selectMultiStationData)?.DataVisualizationDTOs[0];
  const showConfidenceLevel = useSelector(selectShowConfidenceLevel);
  const showInvalidData = useSelector(selectShowInvalidData);
  const showValidData = useSelector(selectShowValidData);

  const selectedDatasetOptions = useSelector(selectSelectedDatasetOptions);
  const selectedDerivedObservatioIds = useSelector(derivedObservatioIds);
  const filteredSelectedDatasets =
    selectedDerivedObservatioIds != null &&
    selectedDerivedObservatioIds.length > 0 &&
    selectedDatasetOptions != null &&
    selectedDatasetOptions.length > 0 != null
      ? selectedDatasetOptions.filter((x) => !selectedDerivedObservatioIds.includes(x.typeId))
      : selectedDatasetOptions;
  const startDate = useSelector(selectStartDate);
  const endDate = useSelector(selectEndDate);
  const selectedUserPresets = useSelector(selectAllUserPresets);
  const selectedDatasets = getSelectedDatasetsByUserPreset(filteredSelectedDatasets, data, selectedUserPresets);

  const [mode, setMode] = useState(FORM_MODE.LIST);

  useEffect(() => {
    if (loading) return;

    if (weatherStations?.length === 0 && weatherStationId == -1) return;
    if (!presetId) return;

    const fetchData = async () => {
      dispatch(
        fetchMultiStationData({
          weatherStationIds: [weatherStations[0].Id],
          weatherStationId,
          presetId,
          forceFetch: false,
          endDate: dataRange.endDate,
          displayRange: dataRange.displayRange,
          isForGraph: false,
          isSelectedDeferOnlyPreset: isSelectedDeferOnlyPreset,
        }),
      );
    };

    fetchData();
  }, [weatherStations, weatherStationId, presetId, dataRange]);

  const postValidationSubmit = (isSubmitted) => {
    if (isSubmitted)
      dispatch(
        fetchData({ forceFetch: true, isForGraph: false, isSelectedDeferOnlyPreset: isSelectedDeferOnlyPreset }),
      );
  };

  return (
    <>
      {loading && (
        <>
          <div style={overlayStyle}></div>
          <div>
            <div className="text-center mt-4" style={spinnerStyle}>
              <p>Loading Data...</p>
              <Spinner animation="border" />
            </div>
          </div>
        </>
      )}
      <Row className="no-gutters mt-1">
        <Col style={{ zIndex: 1 }}>
          {weatherStation && status.multiStationData == STATE_STATUS.SUCCESS && (
            <Container fluid className="m-0 p-0">
              <TableView
                selectedDatasets={selectedDatasets}
                id={1}
                showInvalidData={showInvalidData}
                showConfidenceLevel={showConfidenceLevel}
                showValidData={showValidData}
                pageSize={30}
                tableParentClasses={'obsTable obsTable-table dataTables table-xs'}
                paginationBarClasses={'obsTable pagination'}
              />
            </Container>
          )}
        </Col>
      </Row>
      {weatherStation && (
        <ValidationModal
          weatherStation={weatherStation}
          startDate={startDate.value}
          endDate={endDate.value}
          dataSets={selectedDatasets}
          mode={mode}
          setMode={setMode}
          postValidationSubmit={postValidationSubmit}
        />
      )}
    </>
  );
};

export default DataTableRenderer;
